/* globals require */
/* exported app */

import Vue from 'vue';
import './forms';
import Tortilla from 'tortilla';
import VeeValidate from 'vee-validate';

window.Vue = Vue;
window.Tortilla = Tortilla;
window.events = window.eventsBus = new Vue();
Vue.prototype.$eventsBus = window.events;

Tortilla.Xhr.setDefaultHeaders({
  'X-Requested-With': 'XMLHttpRequest'
});

Tortilla.Xhr.get('/api/session/heartbeat');

Vue.use(VeeValidate, {
  fieldsBagName: 'vFields'
});

Vue.component('crosswind-lp-form', require('./forms/crosswind-lp-form.vue'));
Vue.component('vimeo-component', require('./apps/vimeo-component.vue'));
Vue.component('cookie-consent', require('./apps/cookie-consent.vue'));

const app = new Vue({
    el: '#app',
    data: {
        year: new Date().getFullYear(),
        baseUrl: `${window.location.origin}${window.location.pathname}`,
        utmSource: '',
        utmMedium: '',
        utmCampaign: '',
        utmContent: '',
        gclid: '',
        wbraid: '',
        gbraid: ''
    },
    delimiters: ['<%', '%>'],
    mounted() {
      if(window.location.search) {
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get("_source") || urlParams.get("utm_source")) {
          this.utmSource = urlParams.get("_source") || urlParams.get("utm_source");
        }
        if (urlParams.get("_medium") || urlParams.get("utm_medium")) {
          this.utmMedium = urlParams.get("_medium") || urlParams.get("utm_medium");
        }
        if (urlParams.get("_campaign") || urlParams.get("utm_campaign")) {
          this.utmCampaign = urlParams.get("_campaign") || urlParams.get("utm_campaign");
        }
        if (urlParams.get("_content") || urlParams.get("utm_content")) {
          this.utmContent = urlParams.get("_content") || urlParams.get("utm_content");
        }

        if (urlParams.get("gclid")) {
          this.gclid = urlParams.get("gclid");
        }
        if (urlParams.get("wbraid")) {
          this.wbraid = urlParams.get("wbraid");
        }
        if (urlParams.get("gbraid")) {
          this.gbraid = urlParams.get("gbraid");
        }
      }

      // this.utmSource = localStorage.utmSource ? localStorage.utmSource : this.utmSource;
      // this.utmMedium = localStorage.utmMedium ? localStorage.utmMedium : this.utmMedium;
      // this.utmCampaign = localStorage.utmCampaign ? localStorage.utmCampaign : this.utmCampaign;
      // this.utmContent = localStorage.utmContent ? localStorage.utmContent : this.utmContent;

      // this.gclid = localStorage.seGclid ? localStorage.seGclid : this.gclid;
      // this.wbraid = localStorage.seWbraid ? localStorage.seWbraid : this.wbraid;
      // this.gbraid = localStorage.seGbraid ? localStorage.seGbraid : this.gbraid;
    },
    watch: {
      utmSource(newUtmSource) {
        localStorage.setItem("utmSource", newUtmSource);
      },
      utmMedium(newUtmMedium) {
          localStorage.setItem("utmMedium", newUtmMedium);
      },
      utmCampaign(newUtmCampaign) {
          localStorage.setItem("utmCampaign", newUtmCampaign);
      },
      utmContent(newUtmContent) {
        localStorage.setItem("utmContent", newUtmContent);
      },
      gclid(newgclid) {
          localStorage.setItem("seGclid", newgclid);
      },
      wbraid(newwbraid) {
          localStorage.setItem("seWbraid", newwbraid);
      },
      gbraid(newgbraid) {
          localStorage.setItem("seGbraid", newgbraid);
      }
    }
});



// WEBPACK FOOTER //
// ./resources/components/app-standalone-landing-pages.js